<template>
    <div>
        <breadcrumb :routerList="[{to:'/chanp/reform',title:'改制单列表'},{title:'改制审批'}]"/>
        <div class="h-content">
            <div class="h-row h-mrt0">
                <div class="h-rowIn">
                    <div class="h-rowBox">
                        <el-form :model="f" label-position="right" ref="f" :inline="true" :rules="rules"
                                 class="demo-ruleForm h-formbLine h-formbLine1">
                            <div class="h-rowCon">

                                <div class="h-pieceIn2">
                                    <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                        <h1>研发样机</h1>
                                    </div>
                                    <div class="h-pieceCon2">
                                        <div class="h-formLine Yangbiao">
                                            <el-form-item label="改制需求号" class="h-elformWrap-2" prop="reformId">
                                                <el-input v-model="f.reformId" placeholder="请输入" readonly>
                                                </el-input>
                                            </el-form-item>
                                            <el-form-item label="产品编码" class="h-elformWrap-2" prop="materialCode">
                                                <el-input v-model="f.materialCode" placeholder="请输入" readonly>
                                                </el-input>
                                            </el-form-item>

                                            <el-form-item label="产品型号" class="h-elformWrap-2" prop="materialName">
                                                <el-input placeholder="输入产品编码自动带出" v-model="f.materialName" readonly></el-input>
                                            </el-form-item>

                                            <el-form-item label="数量" class="h-elformWrap-2" prop="number">
                                                <el-input placeholder="请输入"v-model.number="f.number" readonly></el-input>
                                            </el-form-item>

                                            <el-form-item label="产品大类" class="h-elformWrap-2" prop="oneLName">
                                                <el-input placeholder="输入产品编码自动带出" v-model="f.oneLName" readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="备注" class="h-elformWrap-2" prop="remark">
                                                <el-input  v-model="f.remark" ></el-input>
                                            </el-form-item>
                                            <div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="N-chan">
                                    <div class="h-pieceTitle2">
                                        <h1>样机确认</h1>
                                    </div>
                                    <div class="h-pieceCon2">
                                        <div class="h-formLine Yangbiao">
                                            <el-form-item label="生产版本" class="h-elformWrap-2" prop="reformEdition" >
                                                    <brselect category="gaizhi_edition_nx" disabled :v="f.reformEdition" v-model="f.reformEdition"/>
                                            </el-form-item>
                                            <el-form-item label="GEMS立项号" class="h-elformWrap-2" disabled prop="plnnrId">
                                                <el-input  v-model="f.plnnrId" ></el-input>
                                            </el-form-item>
                                            <el-form-item label="成本中心" class="h-elformWrap-2" disabled prop="costCenter">
                                                <brselect category="yj_cost_center" disabled :v="f.costCenter" v-model="f.costCenter"/>
                                            </el-form-item>
                                            <el-form-item label="物料工位" class="h-elformWrap-5" prop="stationlist" >
                                                <el-checkbox-group v-model="f.stationlist" disabled>
                                                    <el-checkbox v-for="item in options" :label="item.code" :key="item.code" >{{item.name}}</el-checkbox>
                                                </el-checkbox-group>
                                            </el-form-item>
                                            <el-form-item label="检测要求" class="h-elformWrap-5" prop="checkRequest">
                                                <el-input type="textarea" placeholder="请输入检测要求" autosize v-model="f.checkRequest" readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="涉及主关件变更的测试计划及测试报告" class="h-elformWrap-5">
                                                <brupload
                                                        :refid="f.id"
                                                        reftype="改制明细测试报告"
                                                        :uploadflag="false"
                                                        :delflag="false"
                                                        :showtime="false"
                                                >
                                                </brupload>
                                            </el-form-item>
                                        </div>
                                    </div>

                                </div>

                                <el-table
                                        ref="multipleTable"
                                        :data="f.reformMainPrototypeDetailList"
                                        border
                                        max-height="500"
                                        style="width: 100%">
                                    <el-table-column label="个性化改制物料明细">
                                        <el-table-column
                                                prop="orderby"
                                                label="序号"
                                                width="50">
                                            <template slot-scope="scope">
                                                {{scope.row.orderby}}
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                                prop="stuf"
                                                label="层级"
                                                :show-overflow-tooltip="true"
                                                width="50">
                                            <template slot-scope="scope">
                                                <div :style="{color: getColor(scope.row.changeBs)}">
                                                    {{scope.row.stuf}}
                                                </div>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                                prop="materialName"
                                                label="物料描述"
                                                :show-overflow-tooltip="true"
                                                width="180">
                                            <template slot-scope="scope">
                                                <div :style="{color: getColor(scope.row.changeBs)}">
                                                    {{scope.row.materialName}}
                                                </div>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                                prop="materialCode"
                                                label="物料专用号"
                                                width="140">
                                            <template slot-scope="scope">
                                                <div :style="{color: getColor(scope.row.changeBs)}">
                                                    {{scope.row.materialCode}}
                                                </div>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                                prop="purchaseGroup"
                                                label="采购组"
                                                width="110">
                                            <template slot-scope="scope">
                                                <div :style="{color: getColor(scope.row.changeBs)}">
                                                    {{scope.row.purchaseGroup}}
                                                </div>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                                prop="materialOrder"
                                                label="物料单耗"
                                                width="90">
                                            <template slot-scope="scope">
                                                <div :style="{color: getColor(scope.row.changeBs)}">
                                                    {{scope.row.materialOrder}}
                                                </div>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                                prop="sobsl"
                                                label="是否虚拟件"
                                                width="90">
                                            <template slot-scope="scope">
                                                <div :style="{color: getColor(scope.row.changeBs)}">
                                                    {{scope.row.sobsl}}
                                                </div>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                                prop="unit"
                                                label="单位"
                                                width="90">
                                            <template slot-scope="scope">
                                                <div :style="{color: getColor(scope.row.changeBs)}">
                                                    {{scope.row.unit}}
                                                </div>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                                prop="number"
                                                label="数量"
                                                width="90"
                                        >
                                            <template slot-scope="scope">
                                                <div :style="{color: getColor(scope.row.changeBs)}">
                                                    {{scope.row.number}}
                                                </div>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                                prop="supplierName"
                                                :show-overflow-tooltip="true"
                                                label="供应商名称"
                                                width="150"
                                        >
                                            <template slot-scope="scope">
                                                <div :style="{color: getColor(scope.row.changeBs)}">
                                                    {{scope.row.supplierName}}
                                                </div>
                                            </template>
                                        </el-table-column>

                                        <el-table-column
                                                prop="changeBs"
                                                :show-overflow-tooltip="true"
                                                label="新增/删除"
                                                width="90"
                                        >
                                            <template slot-scope="scope">
                                                <div :style="{color: getColor(scope.row.changeBs)}">
                                                    {{scope.row.changeBs}}
                                                </div>
                                            </template>
                                        </el-table-column>

                                        <el-table-column
                                                prop="remark"
                                                label="备注"
                                                :show-overflow-tooltip="true"
                                                width="150"
                                        >
                                            <template slot-scope="scope">
                                                <div :style="{color: getColor(scope.row.changeBs)}">
                                                    {{scope.row.remark}}
                                                </div>
                                            </template>
                                        </el-table-column>
                                    </el-table-column>
                                    <!--    <el-table-column label="原版物料对照">
                                            <el-table-column
                                                    prop="sobslold"
                                                    label="层级"
                                                    :show-overflow-tooltip="true"
                                                    width="50">
                                                <template slot-scope="scope">
                                                    <div :style="{color: getColor(scope.row.changeBs)}">
                                                        {{scope.row.sobslold}}
                                                    </div>
                                                </template>
                                            </el-table-column>
                                            <el-table-column
                                                    prop="materialNameOld"
                                                    label="物料描述"
                                                    :show-overflow-tooltip="true"
                                                    width="180">
                                                <template slot-scope="scope">
                                                     <div :style="{color: getColor(scope.row.changeBs)}">
                                                        {{scope.row.materialNameOld}}
                                                    </div>
                                                </template>
                                            </el-table-column>
                                            <el-table-column
                                                    prop="materialCodeOld"
                                                    label="物料专用号"
                                                    width="140">
                                                <template slot-scope="scope">
                                                     <div :style="{color: getColor(scope.row.changeBs)}">
                                                        {{scope.row.materialCodeOld}}
                                                    </div>
                                                </template>
                                            </el-table-column>
                                            <el-table-column
                                                    prop="purchaseGroupOld"
                                                    label="采购组"
                                                    width="110">
                                                <template slot-scope="scope">
                                                    <div :style="{color: getColor(scope.row.changeBs)}">
                                                    {{scope.row.purchaseGroupOld}}
                                                    </div>
                                                </template>
                                            </el-table-column>
                                            <el-table-column
                                                    prop="materialOrderOld"
                                                    label="物料单耗"
                                                    width="100">
                                                <template slot-scope="scope">
                                                     <div :style="{color: getColor(scope.row.changeBs)}">
                                                        {{scope.row.materialOrderOld}}
                                                    </div>
                                                </template>
                                            </el-table-column>
                                            <el-table-column
                                                    prop="sobslold"
                                                    label="是否虚拟件"
                                                    width="90">
                                                <template slot-scope="scope">
                                                    <div :style="{color: getColor(scope.row.sobsl)}">
                                                        {{scope.row.sobslold}}
                                                    </div>
                                                </template>
                                            </el-table-column>
                                            <el-table-column
                                                    prop="unitOld"
                                                    label="单位"
                                                    width="90">
                                                <template slot-scope="scope">
                                                     <div :style="{color: getColor(scope.row.bomChange)}">
                                                        {{scope.row.unitOld}}
                                                    </div>
                                                </template>
                                            </el-table-column>
                                            <el-table-column
                                                    prop="numberOld"
                                                    label="数量"
                                                    width="90"
                                            >
                                                <template slot-scope="scope">
                                                     <div :style="{color: getColor(scope.row.bomChange)}">
                                                        {{scope.row.numberOld}}
                                                    </div>
                                                </template>
                                            </el-table-column>
                                            <el-table-column
                                                    prop="supplierNameOld"
                                                    :show-overflow-tooltip="true"
                                                    label="供应商名称"
                                                    width="150"
                                            >
                                                <template slot-scope="scope">
                                                     <div :style="{color: getColor(scope.row.bomChange)}">
                                                        {{scope.row.supplierNameOld}}
                                                    </div>
                                                </template>
                                            </el-table-column>

                                            <el-table-column
                                                    prop="remarkOld"
                                                    label="备注"
                                                    :show-overflow-tooltip="true"
                                                    width="100"
                                            >
                                                <template slot-scope="scope">
                                                     <div :style="{color: getColor(scope.row.bomChange)}">
                                                        {{scope.row.remarkOld}}
                                                    </div>
                                                </template>
                                            </el-table-column>
                                        </el-table-column>-->
                                </el-table>
                            </div>
                        </el-form>

                    </div>
                </div>
            </div>
         <!--   <div class="h-row">
                <div class="h-rowIn">
                    <div class="h-rowBox">
                        <div class="h-rowCon">
                            <div class="h-pieceIn2">
                                <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                    <h1>审批意见</h1>
                                </div>
                                <div class="h-formLine Yangbiao">
                                    <el-form :model="f" label-position="right" :inline="true"
                                             class="demo-ruleForm h-formbLine h-formbLine1">
                                        <el-form-item label="审批意见" class="h-elformWrap-3 ":required="true">
                                            <el-input v-model="f.shpyj" placeholder="请输入"></el-input>
                                        </el-form-item>
                                    </el-form>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <viewhistory :visible.sync="showhistory" v-if="showhistory" :id="f.instid"/>

            <div class="h-txtCenter h-mrt60">
                <el-button class="h-btn h-bBtn h-bgwhite" @click="backS">返回</el-button>
                <el-button class="h-btn h-bBtn h-bgred" @click="auditFail">驳回</el-button>
                <el-button class="h-btn h-bBtn h-bggreen" @click="auditPass">通过</el-button>
                <el-button class="el-button h-btn el-button&#45;&#45;default" @click="viewpress">审批跟踪</el-button>

            </div>-->


        </div>
    </div>
</template>

<script>
    import reformService from "../../../api/reform/reformService.js";
    import uploaddownexcel from "../../../components/uploaddown/uploaddownexcel";
    import ss from "../../../api/SystemService";
    import _ from "loadsh";
    import big from "big.js";

    export default {
        components: {
            uploaddownexcel,

        },

        data() {
            return {
                showhistory:false,


                //全部物料工位
                options: [],

                //导入Excel
                uploaddownexcelflag: false,

                //带线表单
                f: {
                    agentCode:null, // 经销商编码
                    agentName:null, // 经销商名称
                    areaCode:null, // 区域编码
                    areaName:null, // 区域名称
                    lianqun:null, // 链群`
                    lianqunName:null, // 链群名称
                    materialCode:null, // 物料编码
                    materialName:null, // 物料名称
                    number:null, // 数量
                   /* specificIds:null, // 改制大id
                    specificDivisions:null,//改制大类
                    specificReqs:null, // 改制大描述*/
                    oneLId:null, // 产品大类编码
                    oneLName:null, // 产品大类名称
                    reformPrice:null, // 定制加价（单台）
                    instid:null,
                    reformId:null, // 定制编号
                    typeUserCode:null,//型号经理编码
                    typeUserName:null,//型号经理名称
                    reformType:'',//0生产改制1库存改制
                    reformEdition:'',//生产版本
                    materialStation:null,//物料工位

                    //物料明细
                    reformMainPrototypeDetailList: [{materialName:'',materialCode:'',materialOrder:'',unit:'',number:'',isSelf:'',remark:'',
                        materialNameTh:'',materialCodeTh:'',materialOrderTh:'',numberTh:'',remarkTh:'',supplierNameTh:'',
                        supplierName:'',changeDes:'',     materialNameOld:null,
                        materialCodeOld:null,
                        purchaseGroupOld:null,
                        materialOrderOld:null,
                        unitOld:null,
                        numberOld:null,
                        supplierNameOld:null,
                        remarkOld:null,}],
                    specificList: [{
                        specificId: '',//改制id
                        specificDivision: '',//改制目录
                        specificReform: '',//改制要求
                        reformPrice: '',//单台加价
                        specificType:'',////1目录内改制 2目录外外改制
                        reformNum:0,//改制数量
                    }],

                    //型号经理录入 （个性化定制标准描述）
                    individualizeList:[''],
                    //型号经理录入 (包装标识要求)
                    logoRequestList:[''],

                    remark:null,//备注
                    //选择的物料工位
                    stationlist:[],
                    //审批相关参数
                    taskid:null,
                    optflag:null,
                    shpyj:null,
                    //是否是财务审批节点
                    iscaiwu :false,
                    checkRequest:'',

                },
                //是否是财务审批节点(f 可能被置空所以建了个中间变量提交时赋值)
                iscaiwu :false,

                rules: {
                    reformId:[{required: true, message: '需求号必填', trigger: 'change'}],
                    agentCode: [{required: true, message: '请选择经销商', trigger: 'change'}],
                    agentName: [{required: true, message: '请选择经销商', trigger: 'change'}],
                    areaName: [{required: true, message: '请选择区域', trigger: 'change'}],
                    lianqunName: [{required: true, message: '请选择链群', trigger: 'change'}],
                    materialCode: [{required: true, message: '请选择物料', trigger: 'change'}],
                    materialName: [{required: true, message: '请选择物料', trigger: 'change'}],
                    number: [{required: true, message: '请填写数量', trigger: 'change'}],
                    oneLName: [{required: true, message: '请填产品大类', trigger: 'change'}],
                    reformPrice: [{required: true, message: '请选择改制内容', trigger: 'change'}],
                    reformType: [{required: true, message: '请选择改制类型', trigger: 'blur'}],
                    reformEdition: [{required: true, message: '请选择生产版本', trigger: 'blur'}],
                    stationlist: [{type: 'array', required: true, message: '请至少选择一个物料工位', trigger: 'change'}],



                },
            }
        },
        created() {
            this.f.taskid = this.$route.query.taskid;
            this.f.id =  this.$route.query.ywid;

            //获取物料工位
            this.options = this.$store.getters.dictlist("material_station");

            //财务 reform_caiwu 为内销改制财务审批单独设置
            this.iscaiwu = this.$store.getters.hasRole("reform_caiwu");

            this.query(this.f.id,this.f.taskid);
        },
        methods: {

            query(id,taskId) {
                reformService.selectProById(id,taskId).then(rd => {
                    console.log("rdrdrdrd",rd)
                    this.f = {...this.f,...rd.obj};
                    ///物料工位
                    this.f.stationlist = rd.obj.materialStation? rd.obj.materialStation.split(","): [];
                    //个性化定制标准描述
                    this.f.individualizeList = rd.obj.individualizeReform? rd.obj.individualizeReform.split("##"): [''];
                    //包装标识要求
                    this.f.logoRequestList = rd.obj.logoRequest? rd.obj.logoRequest.split("##"): [''];
                })
            },

            //返回
            backS() {
                this.$router.push({path: "/chanp/reform"});
            },
            viewpress(r){
                this.showhistory = true;
            },
            //驳回
            auditFail() {

                this.f.optflag = '驳回'
                if(!this.f.shpyj){
                    this.$msg.msge("驳回必须输入审批意见！");
                    return;
                }
                this.$msg.confirm("确认提交？", () => {
                    this.submitForm();
                })

            },
            //通过
            auditPass(){
                //财务节点判断单台加价是否全都填写

                var subflag = false;
                this.$refs['f'].validate((valid) => {
                    if (valid) {
                        subflag = true;
                    } else {
                        this.$msg.msge("请完善信息后再提交！");
                        return false;
                    }
                });
                if (subflag == true) {
                    this.f.optflag = '通过'
                    this.$msg.confirm("确认提交？", () => {

                        this.f.materialStation = this.f.stationlist.join(",");

                        this.submitForm();
                    })
                }


            },
            submitForm() {
                this.f.iscaiwu = this.iscaiwu;
                reformService.otherSpPro(this.f).then(rd => {
                    this.$msg.alerts("提交成功！",()=>{
                        //刷新右上角的代办个数
                        this.$store.dispatch("searchTasktotal")
                        //跳转回原页面
                        this.$router.go(-1);
                    })
                })
            },


            //增加行
            adds(){
                var a = {
                    materialName:'',materialCode:'',materialOrder:'',unit:'',number:'',isSelf:'',remark:'',
                    materialNameTh:'',materialCodeTh:'',materialOrderTh:'',numberTh:'',remarkTh:'',supplierNameTh:'',
                    supplierName:'',changeDes:''
                };
                 this.f.reformMainPrototypeDetailList.push(a)
            },

            //删除一行
            delIndex(index){
                this.f.reformMainPrototypeDetailList.splice(index, 1)
            },
            getColor(val){
                //1增加 2改变 3删除
                if(val == '新增'){
                    return 'green';
                }else if(val == 2){
                    return 'orange';
                }else if(val == '删除'){
                    return 'red';
                }else if(val == null || val == ''){

                }
            }

        },
        watch: {
            'f.specificList': {
                immediate: true,
                deep: true,
                handler(newValue, oldValue) {
                    //计算总金额
                    // this.f.reformPrice = _.reduce(_.map(newValue, "reformPrice"), function (sum, v) {
                    //     return new big(sum).plus(v||0).toString();
                    // }, 0)
                    var reformPrice = 0;
                    for(var i = 0;i<newValue.length;i++){
                        reformPrice += newValue[i].reformPrice * newValue[i].reformNum;
                    }
                    this.f.reformPrice = reformPrice;
                },
            },
        },
    }
</script>
<style>
    .Yangbiao .h-elformWrap-2 .el-form-item__label {
        width: 45%;
        text-align: right;
    }

    .Yangbiao .el-form-item__content {
        width: 55%;
    }

    .Yangbiao .h-elformWrap-2 {
        width: 25% !important;
        padding-right: 0.5rem
    }
    .Yangbiao .h-elformWrap-5 {
        width: 74% !important;
        padding-right: 0.5rem
    }


    .Yangbiao .h-elformWrap-3 {
        width: 85% !important;
        padding-right: 0.5rem
    }
    .Yangbiao .h-elformWrap-3 .el-form-item__label {
        width: 12%;
        text-align: right;
    }
    .Yangbiao .h-elformWrap-35 {
        width: 77% !important;
        padding-right: 0.5rem
    }
    .Yangbiao .h-elformWrap-35 .el-form-item__label {
        width: 20%;
        text-align: right;
    }
    .Yangbiao .h-elformWrap-4 {
        width: 100%;
        padding-right: 0.5rem
    }

    .Yangbiao .h-elformWrap-4 .el-form-item__label {
        width: 10%;
    }
    .Yangbiao .h-elformWrap-4 .el-form-item__content {
        width: 89%;
    }
    .Yangbiao .w-elformWrap {
        width: 100% !important;
    }
    .w-elformWrap .el-form-item__label {
        width: 14% !important;
    }
    .w-elformWrap .el-form-item__content {
        width: 86% !important;
    }
    .Yangbiao .h-elformWrap-1 {
        width: 100%;
        padding-right: 0.5rem
    }

    .Yangbiao .h-elformWrap-1 .el-form-item__label {
        width: 14%;
    }

    .Yangbiao .h-elformWrap-1 .el-form-item__content {
        width: 86%;
    }

    .Yangbiao.el-form-item__content .el-select {
        width: 100%;
    }

    .ljjtablepaddings6 .h-tableInput .el-input__inner{
        padding: 0.05rem 0.1rem;
    }
    .ljjtablepaddings6 .h-tableInput .el-input__icon{
        line-height: 0.25rem;
    }
    .bbbb {
        padding-top: 5px;
        margin: 0 20px;
    }

    .hang {
        padding: 20px 0;
        margin-bottom: 0;
        background-color: white;
    }
    .ddform_disable_cls .el-form-item__content .el-input__inner[disabled] {
        color: #868686;
    }
</style>
